import CustomerInformation from "@/components/templates/Checkout/templates/CustomerInformation";
import DeliveryDetails from "@/components/templates/Checkout/templates/DeliveryDetails";
import EventInformation from "@/components/templates/Checkout/templates/EventInformation";
import Recap from "@/components/templates/Checkout/templates/Recap";
import ThankYou from "@/components/templates/Checkout/templates/ThankYou";
import { Locales } from "@/lib/i18n";
import { actions, segments } from "@/locales/segment";

export const getActionFromSlug = (locale: Locales, slug: string) => {
  const localeActions = actions[locale as keyof typeof actions];
  if (!localeActions) return null;

  // Find the action key by matching the slug value directly
  return Object.keys(localeActions).find((key) => localeActions[key] === slug);
};

export const isCheckoutSegment = (locale: Locales, slug: string) => {
  const localeSegments = segments[locale as keyof typeof segments];
  if (!localeSegments) return false;

  return localeSegments.checkout === slug;
};

export const renderCheckoutView = (resolution: Resolution) => {
  const currentSlug = resolution.slugs[0];

  // Check if it's a checkout action
  const action = getActionFromSlug(resolution.locale, currentSlug);

  if (!action) {
    return null; // Invalid slug, will trigger 404
  }

  switch (action) {
    case "event-info":
      return <EventInformation resolution={resolution} />;
    case "customer-info":
      return <CustomerInformation resolution={resolution} />;
    case "delivery":
      return <DeliveryDetails resolution={resolution} />;
    case "recap":
      return <Recap resolution={resolution} />;
    case "thank-you":
      return <ThankYou resolution={resolution} />;
    default:
      return null;
  }
};
